import React, { useEffect, useState } from 'react';
import { Button, Toast, Loading } from 'zarm'; // import { uploadBase64File } from '@/services';
// import NavBar from '@/components/common/NavBar';

import './index.less';

const getWidthAndheight = () => {
  const width = document.documentElement.clientWidth || document.body.clientWidth;
  const height = document.documentElement.clientHeight || document.body.clientHeight;
  return {
    width,
    height
  };
};

const calc = () => {
  const {
    width: winWidth,
    height: winHeight
  } = getWidthAndheight();
  const fixed = Math.min(750, Math.max(Math.min(winWidth, winHeight), 320)) / 375;
  const width = winWidth - 160 * fixed;
  const height = winHeight - 160 * fixed;
  return {
    width,
    height
  };
};

const SignPanel = props => {
  const {
    onCancel,
    onConfirm,
    placeholder
  } = props;
  const [size, setSize] = useState(calc());
  const [isNull, setIsNull] = useState(true);
  const [isDrawing, setIsDrawing] = useState(false);
  const [canvas, setCanvas] = useState(null);
  const [context, setContext] = useState(null);
  const canvasRef = React.useRef(null);
  const canvasBackRef = React.useRef(null);

  const preventScroll = e => {
    e.preventDefault();
  };

  useEffect(() => {
    const _canvas = canvasRef.current;

    const _context = _canvas.getContext('2d');

    _context.lineWidth = 4;
    _context.strokeStyle = 'black';
    setCanvas(canvasRef.current);
    setContext(_context);
  }, [canvas]);
  useEffect(() => {
    const {
      body
    } = document;

    window.onresize = () => {
      setSize(calc());
    }; // body.style.overflow = 'hidden';


    body.addEventListener('touchmove', preventScroll, {
      passive: false
    });
    return () => {
      window.onresize = null; // body.style.overflow = 'unset';

      body.removeEventListener('touchmove', preventScroll, {
        passive: false
      });
    };
  }, []);

  const startDrawing = e => {
    setIsNull(false);
    setIsDrawing(true);
    context.beginPath();
    const {
      clientX: pageX,
      clientY: pageY
    } = e.touches[0];
    context.moveTo(pageX - canvas.offsetLeft, pageY - canvas.offsetTop);
  };

  const draw = e => {
    if (isDrawing == true) {
      const {
        clientX: pageX,
        clientY: pageY
      } = e.touches[0];
      const x = pageX - canvas.offsetLeft;
      const y = pageY - canvas.offsetTop;
      context.lineTo(x, y);
      context.stroke();
    }
  };

  const stopDrawing = () => {
    setIsDrawing(false);
  };

  const clearCanvas = () => {
    context.clearRect(0, 0, canvas.width, canvas.height);
    setIsNull(true);
  };

  const isBlankCanvas = () => {
    const blank = document.createElement('canvas');
    blank.width = size.width;
    blank.height = size.height;
    return canvas.toDataURL() == blank.toDataURL();
  }; // const onChangeFn = async (fileBase64, cb) => {
  //   Loading.show();
  //   const {
  //     data: { code, message, data },
  //   } = await uploadBase64File({
  //     fileBase64,
  //     uploadType: '99',
  //     companyCode,
  //     orderId,
  //   });
  //   Loading.hide();
  //   const { url } = data || {};
  //   if (code === '10000' && url) {
  //     return onChange(url);
  //   }
  //   return Toast.show(message || '服务异常');
  // };
  // 是否需要旋转


  const isNeedRotate = () => {
    const {
      width,
      height
    } = canvas;
    return width < height;
  }; // 旋转图片s


  const rotateImg = () => {
    const currentDOM = canvasBackRef.current;
    const backCtx = currentDOM.getContext('2d');
    backCtx.translate(currentDOM.width / 2, currentDOM.height / 2);
    backCtx.rotate(-90 * Math.PI / 180);
    backCtx.drawImage(context.canvas, -currentDOM.height / 2, -currentDOM.width / 2, currentDOM.height, currentDOM.width);
    return currentDOM;
  };

  const toImageBase64 = () => {
    if (isBlankCanvas()) {
      Toast.show('签名数据为空，请确认');
    } else {
      let dataUrl = (isNeedRotate() ? rotateImg() : canvas).toDataURL('image/tiff');
      dataUrl = dataUrl.replace('data:image/png', 'data:image/tiff');
      onConfirm && onConfirm(dataUrl); // onChangeFn(dataUrl, () => {
      //   toImageURl && toImageURl(dataUrl);
      // });
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "com-sign-wrap"
  }, isNull && /*#__PURE__*/React.createElement("div", {
    className: "sign-placehodler"
  }, placeholder), /*#__PURE__*/React.createElement("canvas", {
    className: "sign-canvas",
    ref: canvasRef,
    width: size.width,
    height: size.height,
    onTouchStart: startDrawing,
    onTouchEnd: stopDrawing,
    onTouchMove: draw,
    onTouchCancel: stopDrawing
  }, "\u518D\u6B21\u7B7E\u540D"), /*#__PURE__*/React.createElement("div", {
    className: "btn-group"
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "primary",
    ghost: true,
    onClick: clearCanvas
  }, "\u6E05\u9664"), /*#__PURE__*/React.createElement(Button, {
    className: "ok",
    theme: "primary",
    onClick: toImageBase64
  }, "\u786E\u8BA4"), /*#__PURE__*/React.createElement(Button, {
    className: "ok",
    theme: "primary",
    ghost: true,
    onClick: onCancel
  }, "\u8FD4\u56DE")), /*#__PURE__*/React.createElement("canvas", {
    ref: canvasBackRef,
    width: size.height,
    height: size.width,
    className: "canvas-back-up"
  }));
};

export default SignPanel;